import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import { environment } from '../environment/production';
import axios from 'axios';
import Header from './Header';
import './ReferenceId.css';

function ReferenceId() {
    const navigate = useNavigate();
    const [referenceId,setReferenceId]=useState('')
    const [apiCall, setApiCall] = useState(0)
    function previewForm(){
        navigate('/preview')
    }
    const options={
    
        headers:{
            'Authorization':sessionStorage.getItem("access_token")
        }
      }
      function getReferenceID(){
        axios.post(environment.apiUrl+"/FinalSubmit/getReferenceID",JSON.stringify({user_id:sessionStorage.getItem("user_id")}),{headers:(options.headers)})
        .then((resp)=>{
            
            setReferenceId(resp.data.data)
        })
      }
    useEffect(() => {
        if (apiCall == 0) {
            if(sessionStorage.getItem("user_id")==null){
                sessionStorage.removeItem("access_token");
                sessionStorage.removeItem("user_id");
                sessionStorage.removeItem("email_id")
                sessionStorage.removeItem("mobile_no")
                sessionStorage.removeItem("first_name")
                sessionStorage.removeItem("middle_name")
                sessionStorage.removeItem("last_name")
                sessionStorage.removeItem("reference_id")
                navigate("/")
              }
            getReferenceID()
        }
        setApiCall(1)
      }, [apiCall,getReferenceID])
  return (
    <>
    <Header/>
    <div className="main">
    
        <div className="container">
            <br/><br/>
        <div className="middle">
            <h5><span className="text-danger"><b>Note:-</b></span> Kindly save this reference id for future communication. The same has also shared with you over the email id <span className="text-primary"><b>{sessionStorage.getItem("email_id")}</b></span></h5>
            <br/>
        <div className="reference_id">
            
            <div className="cloud">
            <h3 className="text-center">Your Reference Id is {referenceId} </h3>
            </div>
           
           </div>
           
        </div>
        
          <button className="btn btn-dark" onClick={previewForm}>Preview</button>
        </div>
        <div className="footer">
            <p className="text-center"><b>Designed and developed by GSTN</b></p>
        </div>
    </div>
    </>
  )
}

export default ReferenceId